import { createContext, Dispatch, SetStateAction } from 'react';

export type ElementsShowInViewType = {
  observer: HTMLElement | null;
  setObserver: Dispatch<SetStateAction<HTMLElement | null>>;
  elementIds: string[];
  setElementIds: Dispatch<SetStateAction<string[]>>;
  currentElementId: string | null;
  disable: () => void;
  enable: () => void;
  pause: (timeInMs: number) => void;
};

const ElementsShowInViewContext = createContext<ElementsShowInViewType>({
  observer: null,
  setObserver: () => {
    throw new Error('Not implemented');
  },
  elementIds: [],
  setElementIds: () => {
    throw new Error('Not implemented');
  },
  currentElementId: null,
  disable: () => {
    throw new Error('Not implemented');
  },
  enable: () => {
    throw new Error('Not implemented');
  },
  pause: () => {
    throw new Error('Not implemented');
  },
});
ElementsShowInViewContext.displayName = 'ElementsShowInView';

export default ElementsShowInViewContext;
